import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import React from 'react'
import type { SortKey, SortState } from './types'

type Props = {
  label: string
  sortKey: SortKey
  sort: SortState
  onSort: (key: SortKey) => void
}

const SortableHeader = ({ label, sortKey, sort, onSort }: Props) => {
  const [css] = useStyletron()
  const isActive = sort?.key === sortKey
  const direction = isActive ? sort?.direction : null
  const ariaSort: 'ascending' | 'descending' | 'none' = isActive
    ? direction === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none'
  const iconClass =
    direction === 'asc'
      ? 'fa-caret-up'
      : direction === 'desc'
      ? 'fa-caret-down'
      : 'fa-sort'
  return (
    <th aria-sort={ariaSort} className={`text-left ${css({ padding: 0 })}`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`d-flex align-items-center bold body-text-4 ${css({
          background: 'none',
          border: 'none',
          color: palette.grey90,
          cursor: 'pointer',
          padding: '14px 24px',
          width: '100%',
          textAlign: 'left',
        })}`}
      >
        {label}
        <i
          className={`fa ${iconClass} ml-auto ${css({
            color: isActive ? palette.grey90 : palette.grey50,
          })}`}
          aria-hidden="true"
        />
      </button>
    </th>
  )
}

export default SortableHeader
